// BASE URL OF BACKEND
// export const API_BASE_URL = "http://localhost:8080/v1";
export const API_BASE_URL =
  "https://w792mlraf7.execute-api.ap-south-1.amazonaws.com/latest/v1";
//TOKEN
export const directToken = localStorage.getItem("token");
// END POINTS FOR LOGIN IN
export const LOGIN = "/auth/login";

// END POINTS FOR USER MANAGEMENT
export const LIST_OF_SPECIALITY = "/specialities/specialities-list";
export const CREATE_SPECIALITY = "/specialities/create-specialities";
export const EDIT_SPECIALITY = "/specialities/Edit-Specialities/";
export const DELETE_SPECIALITY = "/specialities/Delete-Specialities/";

// END POINTS FOR CITY
export const LIST_OF_CITY = "/location/city-list";
export const CREATE_CITY = "/location/addCity";
export const EDIT_CITY = "/location/Edit-city/";
export const DELETE_CITY = "/location/City-Delete/";

// END POINTS FOR AREA
export const LIST_OF_AREA = "/location/area-list";
export const ADD_LOCATION = "/location/create-location";
export const UPDATE_LOCATION = "/location/Edit-Location/";
export const DELETE_LOCATION = "/location/Delete-Location/";

// // END POINTS HOSPITAL
export const LIST_OF_HOSPITAL = "/hospital/hospital-list";
export const CREATE_HOSPITAL = "/hospital/create-hospitalName";
export const EDIT_HOSPITAL = "/hospital/Edit-HospitalName/";
export const DELETE_HOSPITAL = "/hospital/Delete-HospitalName/";

// // END POINTS FOR SPECIALITY
export const CREATE_MASTER_SPECIALITY =
  "/masterSpecialities/master-create-specialities";
export const LIST_OF_MASTER_SPECIALITY =
  "/masterSpecialities/master-speciality-list";
export const EDIT_MASTER_SPECIALITY =
  "/masterSpecialities/Edit-master-Specialities/";
export const DELETE_MASTER_SPECIALITY =
  "/masterSpecialities/Delete-master-Specialities/";

// END POINTS FOR BUSINESS MANAGEMENT
export const LIST_OF_BUSINESS = "/business/business-list";
export const CREATE_BUSINESS = "/business/add-business";
export const EDIT_BUSINESS = "/business/edit-business/";
export const DELETE_BUSINESS = "/business/delete-business/";

//  END POINT DROPDOWN
export const Hospital_DROPDOWN = "/hospital/hospital-list";

// END POINT Appointment
export const APPOINTMENT_LIST = "/Appt/Appt-list/";
export const APPOINTMENT_DELETE = "/Appt/Delete-Appt/";
export const ADD_APPOINTMENT = "/Appt/Booking-Appt";
export const Edit_APPOINTMENT = "/Appt/Edit-Appt/";

// END ROLE
export const Roles_list = "/roles/Roles_list/";
export const Roles_DropDown = "/roles/DropDown/";
export const UPDATE_ROLES = "/roles/roles-update/";

//END PONIS USER
export const USER_LIST = "/user/getuser-list/";
export const CREATE_USER = "/user/create-user";
export const DELETE_USER = "/user/delete/";
export const UPDATE_USER = "/user/update-user/";

// END POINT DOCTOR
export const DOCTOR_LIST = "/doctor/doctor-list/";
export const ADD_DOCOTR = "/doctor/add-doctor";
export const DELETE_DOCTOR = "/doctor/deletedoctor/";
export const UPDATE_DOCTOR = "/doctor/doctorUpdate/";

// SLOTS
export const ADD_SLOTS = "/dateTime/add-dateTime";
export const EDIT_SLOTS = "/dateTime/Edit-Slot/";
export const DELETE_SLOTS = "/dateTime/Delete-Slot/";

// GET BOOK_LIST
export const GET_BOOKLIST = "/dateTime/get-Booked-List/";
